<script setup lang="ts">
import { useAttrs } from 'vue';
import EditIcon from 'src/shared/icons/edit-lined.svg';
import BaseButton from 'src/shared/ui/base-button/base-button.vue';

defineOptions({ inheritAttrs: false });
const attrs = useAttrs();

interface Props {
  disabled?: boolean;
  loading?: boolean;
  label?: string;
  size?: 'l' | 'xl';
}

withDefaults(defineProps<Props>(), {
  label: '',
  size: 'l',
});

const emit = defineEmits<{
  click: [event: MouseEvent];
}>();
</script>

<template>
  <BaseButton
    v-if="label"
    v-bind="attrs"
    class="edit-action-button"
    type="secondary"
    :size="size"
    aria-label="Редактировать"
    :disabled="disabled"
    :loading="loading"
    @click="emit('click', $event)"
  >
    <template #left-icon>
      <EditIcon />
    </template>
    {{ label }}
  </BaseButton>
  <BaseButton
    v-else
    v-bind="attrs"
    class="edit-action-button"
    type="secondary"
    :size="size"
    aria-label="Редактировать"
    :disabled="disabled"
    :loading="loading"
    @click="emit('click', $event)"
  >
    <template #left-icon>
      <EditIcon />
    </template>
  </BaseButton>
</template>

<style scoped>
.edit-action-button {
  color: var(--palette-black);
  -webkit-text-fill-color: var(--palette-black);
}

.edit-action-button :deep(svg),
.edit-action-button :deep(path) {
  color: var(--palette-black);
  stroke: var(--palette-black);
}
</style>
